import Modal from '..';
import useStore from '../../Hooks/useStore';
import Form from '../../Form';
import * as S from './styles';
import { useNavigate } from 'react-router-dom';

const ConfirmSessionModal = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    auth: { emitLogoutConfirmation },
    modal: { setModal },
  } = setters;
  const navigate = useNavigate();

  const isOpen = getModal('single.confirmSession');
  const handleUseHere = () => {
    emitLogoutConfirmation();
    setModal('single.confirmSession', false);
  };
  const handleClose = () => {
    navigate('/');
    setTimeout(() => {
      setModal('single.confirmSession', false);
    }, 100);
  };
  return (
    <Modal isOpen={isOpen} height={'auto'} width={'35vw'}>
      <S.Body>
        O tools está aberto em outra janela. Clique em "Usar nesta janela" para
        usar o tools nesta janela.
      </S.Body>
      <S.ButtonsContainer>
        <Form.Button
          style={{
            height: '40px',
            width: '200px',
            margin: 'auto',
            padding: '0.5rem 2rem 0.5rem 2rem',
            color: 'white',
            fontWeight: 400,
            fontSize: '18px',
            background: '#6f6f6f',
            borderRadius: '10px',
          }}
          onClick={handleClose}
        >
          Fechar
        </Form.Button>
        <Form.Button
          style={{
            height: '40px',
            width: '200px',
            margin: 'auto',
            padding: '0.5rem 0',
            color: 'white',
            fontWeight: 400,
            fontSize: '18px',
            background: '#11465D',
            borderRadius: '10px',
          }}
          onClick={handleUseHere}
        >
          Usar nesta janela
        </Form.Button>
      </S.ButtonsContainer>
    </Modal>
  );
};

export default ConfirmSessionModal;
